module.exports = __webpack_public_path__ + "img/doc_mdp.915d48f5.gif";